import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { styled } from "@mui/system";

export const ArelTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} placement="top" arrow />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: 13,
    backgroundColor: "#000000",
    padding: "7px 14px",
    borderRadius: "10px"
  },
  [`& .${tooltipClasses.arrow}`]: {
    "&:before": {
      backgroundColor: "#000000",
    },
  },
}));
